
import ClickOutside from "vue-click-outside";

export default {
	name: "CustomSelect",
	directives: {
		ClickOutside,
	},
	props: {
		options: {
			type: Array,
			required: true,
		},
		startValue: {
			type: String,
			required: false,
			default: null,
		},
		disabled: {
			type: Boolean,
		},
	},
	data() {
		return {
			currentValue: null,
			isOpen: false,
		};
	},
	computed: {
		currentOption() {
			return this.options.find(
				(option) => option.value === this.currentValue
			);
		},
		currentLabel() {
			return this.currentOption?.label;
		},
	},
	created() {
		const startOption = this.options.find(
			(o) => o.value === this.startValue
		);
		if (startOption) {
			this.currentValue = startOption.value;
		} else {
			this.currentValue = this.options[0].value;
		}
	},
	methods: {
		onClickOutside() {
			this.isOpen = false;
		},
		onMainButtonClick() {
			if (!this.disabled) {
				this.isOpen = !this.isOpen;
			}
		},
		onOptionClick(option) {
			if (option.value !== this.currentValue) {
				this.currentValue = option.value;
				this.$emit("change", option.value);
			}

			this.isOpen = false;
		},
	},
};
